import { ReactNode } from 'react'

import { EducationHostedFormProps, EducationHostedFormSteps } from './EducationHostedForm.types'
import { SelectOrganisation } from './SelectOrganisation/SelectOrganisation'
import { AddOrganisation } from './AddOrganisation/AddOrganisation'
import { AgentDetails } from './AgentDetails/AgentDetails'
import { DocumentUpload } from './DocumentUpload/DocumentUpload'
import { OrganisationAddress } from './OrganisationAddress/OrganisationAddress'
import { Otp } from './Otp/Otp'
import { Terms } from './Terms/Terms'
import { ProcessingPage } from './ProcessingPage/ProcessingPage'
import { ResultPage } from '@percent/education-hosted-form/ui'
import { useEducationHostedForm } from '@percent/education-hosted-form/hooks/useEducationHostedForm/useEducationHostedForm'
import { GOODSTACK_EDU_HELP_CENTER_URL } from '@percent/education-hosted-form/constants'
import CompleteSVG from '@percent/education-hosted-form/assets/icons/complete.svg'
import RejectedSVG from '@percent/education-hosted-form/assets/icons/rejected.svg'

// Pick the copy that matches who sends the outcome email.
function PendingApprovalResult() {
  const { partnerConfig } = useEducationHostedForm()
  const description = partnerConfig?.configuration.shouldSendOutcomeEmail
    ? 'pendingApplicationApproved.outcomeSentByGoodstack'
    : 'pendingApplicationApproved.outcomeSentByPartner'

  return <ResultPage title="pendingApplicationApproved.title" description={description} imgSrc={CompleteSVG} />
}

export const formSteps: { [key in EducationHostedFormSteps]: ReactNode } = {
  [EducationHostedFormSteps.SELECT_ORGANISATION]: <SelectOrganisation />,
  [EducationHostedFormSteps.ADD_ORGANISATION]: <AddOrganisation />,
  [EducationHostedFormSteps.ORGANISATION_ADDRESS]: <OrganisationAddress />,
  [EducationHostedFormSteps.AGENT_DETAILS]: <AgentDetails />,
  [EducationHostedFormSteps.OTP]: <Otp />,
  [EducationHostedFormSteps.PROCESSING_PAGE]: <ProcessingPage />,
  [EducationHostedFormSteps.DOCUMENT_UPLOAD]: <DocumentUpload />,
  [EducationHostedFormSteps.TERMS]: <Terms />,
  [EducationHostedFormSteps.APPROVED]: (
    <ResultPage title="applicationApproved.title" description="applicationApproved.description" imgSrc={CompleteSVG} />
  ),
  [EducationHostedFormSteps.PENDING_APPROVE]: <PendingApprovalResult />,
  [EducationHostedFormSteps.REJECTED]: (
    <ResultPage
      title="applicationRejected.title"
      description="applicationRejected.description"
      imgSrc={RejectedSVG}
      helpCenterUrl={GOODSTACK_EDU_HELP_CENTER_URL}
      shouldRedirect={false}
      step={EducationHostedFormSteps.REJECTED}
    />
  ),
  [EducationHostedFormSteps.OTP_MAX_ATTEMPTS_EXCEEDED]: (
    <ResultPage
      title="otpMaxAttemptsExceeded.title"
      description="otpMaxAttemptsExceeded.description"
      imgSrc={RejectedSVG}
      helpCenterUrl={GOODSTACK_EDU_HELP_CENTER_URL}
      shouldRedirect={false}
      step={EducationHostedFormSteps.OTP_MAX_ATTEMPTS_EXCEEDED}
    />
  )
}

export function EducationHostedForm({ formStep }: EducationHostedFormProps) {
  const currentPage = formSteps[formStep]

  if (!currentPage) {
    return null
  }

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{currentPage}</>
}
